import { ALLOWED_ACTIONS_COUNT, SLUG_PREFIX } from 'constants/customRecords';

/**
 * Filter out resources that do not meet criteria (allowed actions = 11 & slug begins with 'c__').
 * CRM provides resources for every table and every field in those tables.  This function will
 * limit the results to only the tables.

 * @param {Array} customPermissions CRM Service Resources
 */
export const filterCustomPermissions = (customPermissions) => {
  return customPermissions?.filter(
    (record) =>
      record.allowed_actions.length === ALLOWED_ACTIONS_COUNT &&
      record.slug.startsWith(SLUG_PREFIX),
  );
};

/**
 * Translate a resource record into the format for permission macros.
 *
 * @param {Object} permission Singular result from CRM Service Resources
 */
export const convertResourceToMacro = (permission) => {
  return {
    id: permission.slug,
    name: permission.name,
    description: `Set permissions for ${permission.name}.`,
    type: 'crud',
    toggles: [],
  };
};
